import { FullTextMode } from "./../document-state";
import { QueryComponentsCollection } from "./../../../search/collections/query-components";
import { BasicTabState } from "./basic-tab-state";
import {prop} from "../../../decorators/property";

export class FulltextTabState extends BasicTabState {

    @prop() public QueryComponents: QueryComponentsCollection = new QueryComponentsCollection();
    @prop() public ParagraphNumber: number;
    @prop() public FullTextMode = FullTextMode.Text;
    @prop() public ScrollPosition: any; // TODO figure out what type this is
    @prop() public ShowHeaderControls: boolean;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/fulltext-state.ts